import React from 'react';
import { Link } from 'react-router-dom';
import './MotorInsurance.css';

const PassengerCarryingVehicle = () => {
  return (
    <div className="motor-insurance-module">
      <div className="admin-header">
        <div className="container">
          <div className="admin-header-content">
            <div>
              <h1>Motor – Passenger Carrying Vehicle Quotation Module</h1>
              <p>Create passenger carrying vehicle insurance quotations</p>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-content">
        <div className="container">
          <div className="module-placeholder card">
            <h2>Passenger Carrying Vehicle Insurance Quotation Builder</h2>
            <p>This module is under development. Detailed quotation builder will be implemented here.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassengerCarryingVehicle;

